export const TOP_UP_RECOGNITION_POINTS = [
    'Users will receive a one-time top-up to their recognition points balance.',
    'This is a temporary adjustment for the current month',
];
